import React from 'react'

const PropertyFinderAppUIProject = () => {
  return (
    <div>
        {/* collapseSixtyFour */}
        <div className="accordion-item mb-2">
            <h2 className="accordion-header" id="headingSixtyFour">
                <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSixtyFour" aria-expanded="false" aria-controls="collapseSixtyFour">
                    Property Finder App UI – Project <span className="toggle-icon ms-auto"></span>
                </button>
            </h2>
            <div id="collapseSixtyFour" className="accordion-collapse collapse" aria-labelledby="headingSixtyFour" data-bs-parent="#accordionCourses">
                <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <ul>
                        <li>Starting a New App</li>
                        <li>A Property Card</li>
                        <li>Property Details</li>
                        <li>Intent to a Property</li>
                        <li>Populating Text Data</li>
                        <li>Main Activity Data</li>
                        <li>Bundle of Extras</li>
                        <li>Fetching Extras</li>
                        <li>Populating Image Data</li>
                        <li>Fetching Image Data</li>
                        <li>Clicking on the Image View</li>
                        <li>Finishing Up</li>
                    </ul>

                </div>
            </div>
        </div>

    </div>
  )
}

export default PropertyFinderAppUIProject